import { useEffect, useRef, useState } from 'react';

//* Styles
import HeroIndividualServiceStyle from './style';

//* Components
import Text from '@/components/Text';
import Image from '@/components/Image';
import Container from '@/components/Container';
import { textWriter } from '@/components/Animation/util';
import useTrigger from '@/components/Animation/useTrigger';

const HeroIndividualService = ({ image, title }) => {
	//! State
	const [load, setLoad] = useState(false);

	//! Ref
	const styleRef = useRef();
	const refText = useRef();

	useEffect(() => {
		const trigger = useTrigger({
			ref: styleRef.current,
			documentPercent: 20,
			once: true,

			onEnter: () => {
				if (load) {
					styleRef.current.classList.add('active');

					setTimeout(() => {
						textWriter(refText.current);
					}, 400);
				}
			},
		});
		return () => {
			trigger();
		};
	}, [load]);

	return (
		<HeroIndividualServiceStyle ref={styleRef}>
			<div className='image-text-wrapper'>
				<Image
					onLoad={setLoad}
					src={image.src}
					alt={image.alt}
				/>
				<Container className='wrapper-info'>
					<div className='inner-wrapper'>
						<Text
							tag={'h1'}
							ref={refText}
							className={'title-service-hero font-montserrat-arm-medium h1 uppercase'}>
							{title}
						</Text>
					</div>
				</Container>
			</div>
		</HeroIndividualServiceStyle>
	);
};

export default HeroIndividualService;
